import React, { useMemo, type FC } from 'react'

import { useIntl } from 'react-intl'

import { Select } from 'mailup-web-components'

import { dynamicFieldsState } from 'Pages/RecipientsList/recoil/state/columns'
import { identifierState } from 'Pages/RecipientsList/recoil/state/filters'

import { changeIdentifierCallback } from 'Pages/RecipientsList/recoil/callbacks/filters'

import type { Identifier } from 'Pages/RecipientsList/model'
import { useRecoilCallback, useRecoilValue } from 'recoil'

interface InputIdentifierProps {
  index: number
}

const InputIdentifier: FC<InputIdentifierProps> = ({ index }) => {
  const intl = useIntl()

  const identifier = useRecoilValue(identifierState(index))

  const dynamicFields = useRecoilValue(dynamicFieldsState)

  const changeIdentifier = useRecoilCallback(changeIdentifierCallback, [])

  const options = useMemo(() => {
    return [
      {
        value: 'Email',
        label: intl.formatMessage({ id: 'Load.MailupCommon.Email' }),
      },
      {
        value: 'MobileNumber',
        label: intl.formatMessage({ id: 'Load.MailupCommon.TelephoneNumber' }),
      },
      {
        value: 'MobilePrefix',
        label: intl.formatMessage({
          id: 'Load.RecipientsList.IdentifierMobilePrefix',
        }),
      },

      ...dynamicFields.map(({ id, description }) => ({
        value: `Field${id}`,
        label: `${id} - ${description}`,
      })),
    ]
  }, [dynamicFields, intl])

  const handleChange = (identifier: Identifier): void => {
    void changeIdentifier(identifier, index)
  }

  return (
    <Select
      value={identifier}
      placeholder={intl.formatMessage({
        id: 'Load.RecipientsList.SelectIdentifierPlaceholder',
      })}
      options={options}
      onChange={handleChange}
    />
  )
}

export default InputIdentifier
